<template>
  <a-form-item
    :label="varLabel"
    :label-col="formItemLayout.labelCol"
    :wrapper-col="formItemLayout.wrapperCol"
  >
    <a-input
      :size="size"
      :disabled="disabled"
      v-decorator="[varName, { 
                    rules: [{ required: varRequired, message: message}],
                    initialValue: varInitial
                    }]"
      :placeholder="varLabel"
    />
    <a-alert :message="description" type="info" showIcon style="margin-top:5px;" v-if="description" />
  </a-form-item>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";

export default {
  mixins: [formLayoutMixin],
  props: {
    varName: String,
    varLabel: String,
    varInitial: String,
    varRequired: Boolean,
    formLayout: String,
    description: [String, null],
    disabled: {
      type: Boolean,
      default: false
    },
    size: String
  },
  computed: {
    message() {
      return `Please enter ${this.varLabel.toLowerCase()}`;
    }
  }
};
</script>
